import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

interface Props {}

const PublicReportPageError: React.FC<Props> = (): React.ReactElement => {
  const { t } = useCustomTranslation();

  return (
    <div className="PublicReportPage_notFound">
      <div className="PublicReportPage_notFound-title">{t('report.error.title')}</div>
      <div className="PublicReportPage_notFound-message">{t('report.error.message')}</div>
    </div>
  );
};

export default PublicReportPageError;
